export const getWordCount = (value = '') => {
  const trimmed = String(value || '').trim();
  if (!trimmed) return 0;
  return trimmed.split(/\s+/).filter(Boolean).length;
};

export const isContentWithinLimit = (value = '', maxWords = 50) => {
  return getWordCount(value) <= maxWords;
};

export const truncateToWordLimit = (value = '', maxWords = 50) => {
  const words = String(value || '').trim().split(/\s+/).filter(Boolean);
  if (words.length <= maxWords) return value ?? '';
  return words.slice(0, maxWords).join(' ');
};

export const resolveExclusiveToggle = (toggleName, currentSlider, currentBreaking) => {
  if (toggleName === 'slider') {
    const nextSlider = !currentSlider;
    return {
      slider: nextSlider,
      breaking: nextSlider ? false : currentBreaking,
    };
  }

  if (toggleName === 'breaking') {
    const nextBreaking = !currentBreaking;
    return {
      slider: nextBreaking ? false : currentSlider,
      breaking: nextBreaking,
    };
  }

  return {
    slider: currentSlider,
    breaking: currentBreaking,
  };
};
